import { FC } from "react";
import { UserInfo } from "../UserInfo";
import { TravelInfo } from "../TravelInfo";
import { EditBlockWrapper } from "./styles";

export const EditBlock: FC = () => (
  <EditBlockWrapper>
    <UserInfo />
    <TravelInfo />
  </EditBlockWrapper>
);
